import api from './api';
import { User } from '../types';

export const usersService = {
    getProfile: async (): Promise<User> => {
        const response = await api.get('/users/me');
        return response.data;
    },

    updateProfile: async (data: Partial<User> & { password?: string }): Promise<User> => {
        const response = await api.patch('/users/me', data);
        return response.data;
    },

    getAllUsers: async (): Promise<User[]> => {
        const response = await api.get('/users');
        return response.data;
    },

    updateUserRole: async (userId: string, role: string): Promise<User> => {
        const response = await api.patch(`/users/${userId}/role`, { role });
        return response.data;
    },

    updateUserPermissions: async (userId: string, permissions: string[]): Promise<User> => {
        const response = await api.patch(`/users/${userId}/permissions`, { permissions });
        return response.data;
    },

    createUser: async (userData: any): Promise<User> => {
        const response = await api.post('/users', userData);
        return response.data;
    },

    updateAnyUser: async (userId: string, userData: any): Promise<User> => {
        const response = await api.patch(`/users/${userId}`, userData);
        return response.data;
    },

    adminDeleteUser: async (userId: string): Promise<void> => {
        await api.delete(`/users/${userId}`);
    },

    deleteAccount: async (): Promise<void> => {
        await api.delete('/users/me');
    }
};
